import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import KeystrokeInputableText from '@/components/keystrokeInputableText/KeystrokeInputableText.vue';

import { InputableTextMixin } from '@/components/inputableText/InputableText';
import KeystrokePropsMixin from '@/entries/user/mixins/KeystrokePropsMixin';
import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';

import { CellTagType, 返済原資ListItemCell } from '@/classes/service/計画/返済計画Service';

export default mixins(InputableTextMixin, KeystrokePropsMixin, 計画書Mixin).extend({
  name: 'C返済原資Cell',

  components: {
    KeystrokeInputableText,
  },

  props: {
    cell: {
      type: Object as PropType<返済原資ListItemCell>,
      required: true,
    },
    colspan: {
      type: Number,
      default: 1,
    },
  },

  data(): {
    readonly cellTagType: typeof CellTagType;
  } {
    return {
      cellTagType: CellTagType,
    };
  },

  computed: {
    value(): unknown {
      // referenceが存在、かつ値が設定されている場合はreferenceを表示
      // それ以外はfixを表示
      const ref = this.cell.reference?.object[this.cell.reference?.key];
      return ref === undefined ? this.cell.fix : ref;
    },
  },

  filters: {
    cellCss(type: CellTagType): string {
      switch (type) {
        case CellTagType.inputCurrency:
        case CellTagType.inputText:
          return 'white';
        case CellTagType.inputPercent:
          return 'white per';
        default:
          return '';
      }
    },
  },

  methods: {
    onChange(v: string | number): void {
      // 入力はreferenceが存在する場合の想定
      const ref = this.cell.reference;
      if (ref === undefined) throw new Error('返済原資Cell#onChange: Illegal input cell');
      this.$set(ref.object, ref.key, v);
      this.$emit('change');
    },
  },
});
